<capra-icon
  class="metadata-popover-button"
  mat-button
  #menuTrigger="matMenuTrigger"
  [matMenuTriggerFor]="menu"
  icon="icon-info-outline"
  [ngClass]="{ 'metadata-popover-is-open': menuTrigger.menuOpen }"
  data-test="metadata-popover-button"
></capra-icon>
<ng-template #loading>
  <div class="loading">
    <mode-animated-refresh-icon class="refresh-icon"></mode-animated-refresh-icon>
    <span class="loading-text">Loading...</span>
  </div>
</ng-template>
<mat-menu #menu="matMenu" class="wide-menu-contents">
  <span class="metadata-report-header">Report Activity</span>
  <ul class="metadata-list">
    <li class="metadata-row">
      <strong>Total Report views</strong>
      <div *ngIf="!dbtDataLoading; else loading">{{ numberOfViews }}</div>
    </li>
    <li class="metadata-row">
      <strong>Report last edited</strong>
      <span *ngIf="!dbtDataLoading; else loading">
        <mode-time-ago *ngIf="lastEdit" [date]="lastEdit"></mode-time-ago>
      </span>
    </li>

    <li class="metadata-row">
      <strong>Report last successfully refreshed</strong>
      <span *ngIf="!dbtDataLoading; else loading">
        <mode-time-ago *ngIf="lastSuccessfulRun" [date]="lastSuccessfulRun"></mode-time-ago>
      </span>
    </li>
    <li class="metadata-icon-row" *ngIf="datasetLastRefreshed">
      <capra-icon icon="icon-dataset"> </capra-icon>
      <strong data-test="dataset-last-run">Dataset source data last run</strong>
      <mode-time-ago [date]="datasetLastRefreshed"></mode-time-ago>
    </li>
    <li *ngIf="dbtTables?.length" class="metadata-row metadata-dbt-row">
      <strong class="dbt-freshness-label"><span class="icon-dbt-logo"></span> Source data last refreshed</strong>
      <section [ngSwitch]="dbtStatus">
        <div *ngSwitchCase="'error'" class="dbt-freshness-value">
          <!-- dbt error -->
          <capra-icon
            icon="icon-warning"
            class="dbt-error"
            capraTooltip
            [tooltipContent]="dbtErrorMessage"
            tooltipPlacement="bottom"
          ></capra-icon>
          <mode-time-ago *ngIf="dbtSourceLastLoadTime" [date]="dbtSourceLastLoadTime"></mode-time-ago>
          <span *ngIf="!dbtSourceLastLoadTime">Data unavailable</span>
        </div>
        <!-- dbt info warning -->
        <div *ngSwitchCase="'info'" class="dbt-freshness-value">
          <capra-icon
            icon="icon-info-outline"
            class="dbt-warning"
            capraTooltip
            [tooltipContent]="dbtMessage"
            tooltipPlacement="bottom"
          ></capra-icon>
          <mode-time-ago *ngIf="dbtSourceLastLoadTime" [date]="dbtSourceLastLoadTime"></mode-time-ago>
        </div>
        <!-- dbt ok -->
        <div *ngSwitchCase="'ok'" class="dbt-freshness-value">
          <mode-time-ago *ngIf="dbtSourceLastLoadTime" [date]="dbtSourceLastLoadTime"></mode-time-ago>
        </div>
      </section>
    </li>
  </ul>

  <div *ngIf="referencedDatasources?.length && userCanEditReport" class="referenced-datasources">
    <span class="metadata-report-header">Referenced Data</span>
    <ul class="metadata-list">
      <li *ngFor="let datasource of referencedDatasources" class="metadata-row">
        <span class="datasource-name">
          <capra-icon class="icon-database" icon="icon-database"></capra-icon>
          <span class="overflow-wrapper">{{ datasource.displayName }} </span>
        </span>
        <mode-datasource-access-level
          class="datasource-access-level"
          [accessLevel]="datasource.defaultAccessLevel"
        ></mode-datasource-access-level>
      </li>
    </ul>
  </div>

  <div class="details-link-container">
    <a [href]="detailsRouteUrl">View Report Details</a>
  </div>
</mat-menu>
